import { atom } from 'recoil';

const loginInit = atom<boolean>({
  key: 'loginInit',
  default: false,
});

export default loginInit;
